module.exports = san.defineComponent({
    template: require('../views/qjzxAnli.html'),
    initData: function () {
        return {
            caseUrl: '',
            showFlag: false,
            load: {
                name: '',
                context: '发送中'
            },
            showLoading: true,
            html: '',
            showCompany: false
        };
    },
    components: {

    },
    created: function () {
        document.documentElement.scrollTop = 0;
    },
    showCompany: function () {
        this.data.set('showCompany', true);
    },
    getAnli: function (caseName) {
        var me = this;
        me.data.set('html', '');
        this.data.set('showLoading', true);
        var data = {
            filename: caseName.value,
            path: "https://shidu-sceneconsult.oss-cn-hangzhou.aliyuncs.com/case/" + encodeURIComponent(caseName.value, 'utf-8') + ".docx",
            suf: "docx"
        };
        Api("post", window.Apipath.returnHtml(), JSON.stringify(data)).then(function (resp) {
            var reg = /style\s*?=\s*?([‘"])[\s\S]*?\1/;
            var reg2 = /font-size:14.0pt;/g;
            var reg3 = /text-align:\s*?right;/g;
            var reg4 = /text-indent:\S*?pt;/g;
            var reg5 = /href\s*?=\s*?([‘"])[\s\S]*?\1/g;
            var changeHtml = resp.html.replace(reg, '').replace(reg2, '').replace(reg3, '').replace(reg4, '').replace(reg5, '');
            san.nextTick(function () {
                me.data.set('html', changeHtml);
            });
            me.data.set('showLoading', false);
            document.documentElement.scrollTop = 0;
        });
    },
    load: function () {
        this.data.set('showLoading', false);
    },
    messages: {

    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/qjzxAnli.js
// module id = 372
// module chunks = 1